import { Avatar, Button, Drawer, Form } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { EditOutlined } from "@ant-design/icons";
import TopHeading from "./TopHeading";
import Empty from "../common/Empty";
import AddFeedbackType from "./AddFeedbackType";

const FeedbackTypeList = () => {
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [FeedbackTypeData, setFeedbackTypeData] = useState({
    loading: false,
    data: null,
  });
  const [selectedFeedbackTypeForEdit, setSelectedFeedbackTypeForEdit] =
    useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const getFeedbackType = useCallback(async () => {
    setFeedbackTypeData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(`${encodedUri}/admin/feedback-type/all`, {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      })
      .then((res) => {
        setFeedbackTypeData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setFeedbackTypeData({ loading: false, data: [] });
        console.error("Feedback Type: Error", err);
      });
  }, []);

  useEffect(() => {
    getFeedbackType();
  }, [getFeedbackType]);

  useEffect(() => {
    if (visible) {
      setSelectedFeedbackTypeForEdit(undefined);
    }
  }, [selectedFeedbackTypeForEdit]);

  useEffect(() => {
    setSelectedFeedbackTypeForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedFeedbackTypeForEdit(null);
    getFeedbackType();
  };

  return (
    <React.Fragment>
      <TopHeading
        {...FeedbackTypeData?.data?.totalElements}
        refetch={getFeedbackType}
      />

      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Feedback Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {FeedbackTypeData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {FeedbackTypeData?.data?.feedbackTypes?.length ? (
                    FeedbackTypeData?.data?.feedbackTypes?.map(
                      (feedbackType: any, index: any) => (
                        <React.Fragment key={index}>
                          <div className="single-product-wrapper">
                            <div className="single-product">
                              <Avatar
                                shape="square"
                                size={45}
                                src={feedbackType?.icon}
                                className="mr-3"
                              />
                              <span className="name">{feedbackType?.name}</span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                {feedbackType?.type?.replace("_", " ")}
                              </span>
                            </div>

                            <div className="single-product">
                              <span className="name">
                                {feedbackType?.displayOrder}
                              </span>
                            </div>

                            <div className="single-product">
                              <Button
                                onClick={() =>
                                  setSelectedFeedbackTypeForEdit(feedbackType)
                                }
                              >
                                <EditOutlined />
                              </Button>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="FeedbackTypes" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title="Edit FeedbackType"
            width={500}
            onClose={onClose}
            visible={selectedFeedbackTypeForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            <AddFeedbackType
              visibleData={selectedFeedbackTypeForEdit}
              onCloseMethod={onClose}
            />
          </Drawer>

          <PaginationTwo
            {...FeedbackTypeData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default FeedbackTypeList;
